import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNDocument } from '../models/sndocument';

@RegisterItem()
export class CNDocument extends SNDocument {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNDocument.CNDocument';
    }

    public clone(): any {
        return new CNDocument();
    }
}

